// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"859":"1c99af6b","888":"39a85375"}[chunkId] + ".css";
};